module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-dla-klasy-1-mj-2.e1786dba.png";